import isEqual from 'react-fast-compare';

import {NOT_ARCHIVED_PURPOSE_STRING} from 'archive/ArchiveConstants';
import {DEFAULT_PAGE_SIZE} from 'nav/sidepanel/PageSizeUtil';
import {Thunk} from 'redux-stores/Store';
import {searchAssayRuns} from 'results/assays/AssayRecordActions';
import {
  Filter,
  FilterKey,
  keyToEmptyFilter,
  MultiValueFilter,
  SearchParams,
  SingleValueFilter,
} from 'search/SearchConstants';

import {AvailabilityStatus} from './RunsInboxModalConstants';

function assayRunSearchParams(schemaId: string, filters: Array<Filter>, offset: number = 0): SearchParams {
  return {
    offset,
    limit: DEFAULT_PAGE_SIZE,
    query: '',
    filters: [
      ...filters,
      {
        ...keyToEmptyFilter(FilterKey.SCHEMA),
        value: [schemaId],
      },
    ],
    sorts: [],
    groupBy: null,
  };
}

export function fetchAssayRuns(schemaId: string, filters: Array<Filter>, offset?: number): Thunk<void> {
  const statusFilter = filters.find(
    (filter) => filter.key === FilterKey.RUN_AVAILABILITY
  ) as SingleValueFilter;
  const archiveFilter = filters.find(
    (filter) => filter.key === FilterKey.ARCHIVE_PURPOSES
  ) as MultiValueFilter;

  return searchAssayRuns({
    searchParams: assayRunSearchParams(schemaId, filters, offset),
    level:
      statusFilter.value === AvailabilityStatus.AVAILABLE &&
      isEqual(archiveFilter.value, [NOT_ARCHIVED_PURPOSE_STRING])
        ? 'write'
        : 'read',
  });
}

export function fetchMoreAssayRuns(schemaId: string, filters: Array<Filter>): Thunk<void> {
  return (dispatch, getState) => {
    const {offset} = getState().ui.results.runsInboxModal;
    dispatch(fetchAssayRuns(schemaId, filters, offset));
  };
}

export enum RunsInboxModalActionType {
  CHANGE_FILTERS = 'CHANGE_FILTERS',
  RESET_STATE = 'RUNS_INBOX_RESET_STATE',
  SELECT_RUN = 'RUNS_INBOX_SELECT_RUN',
}
export interface ChangeFiltersAction {
  type: RunsInboxModalActionType.CHANGE_FILTERS;
  filters: Array<Filter>;
}
export function changeFilters(filters: Array<Filter>): ChangeFiltersAction {
  return {
    type: RunsInboxModalActionType.CHANGE_FILTERS,
    filters,
  };
}

export interface ResetStateAction {
  type: RunsInboxModalActionType.RESET_STATE;
}

export function resetState(): ResetStateAction {
  return {
    type: RunsInboxModalActionType.RESET_STATE,
  };
}

export interface SelectRunAction {
  type: RunsInboxModalActionType.SELECT_RUN;
  runId: string;
}

export function selectRun(runId: string): SelectRunAction {
  return {
    type: RunsInboxModalActionType.SELECT_RUN,
    runId,
  };
}

export type RunsInboxModalAction = ChangeFiltersAction | ResetStateAction | SelectRunAction;
